<template>
  <router-view />
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    computed: {
        ...mapGetters([
            'site',
        ]),
    },
    async beforeRouteUpdate(to, from, next) {
        if (from.params.documentId !== to.params.documentId) {
            if (await this.getSiteDocument(this.site.id, to.params.documentId)) {
                next();
            }
        } else {
            next();
        }
    },
    methods: {
        ...mapActions([
            'getSiteDocument',
        ]),
    },
};
</script>
